module.exports = __webpack_public_path__ + "media/lobby_normal6.ff0115f8.mp3";